import { createFileRoute } from "@tanstack/react-router";
import ContactUsPage from "@/site/pages/contact-us";

// Old app's Contact Us support hub lived at /contact.
export const Route = createFileRoute("/contact")({
  component: ContactUsPage,
});
